<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title step__title_smspace">Прикрепите документы</h3>
      <p class="step__subtitle">Документы могут быть в формате pdf, jpg, png, tiff, каждый не больше 10 мб.</p>
      <template v-if="this.form.event.risktype == 'Жизнь/Здоровье'">
        <p class="step__text">Заполненный бланк Заявления (от каждого Выгодоприобретателя, если данное заявление не
          содержит всей информации)</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(0, $event)" name="files-blank[]"
          v-model="form.files.blank" />
        <p class="step__text">Паспорт (основной разворот и страница с пропиской)</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(1, $event)"
          name="files-passport[]" v-model="form.files.passport" />
      </template>
      <template v-if="dynamicFields.vipiska">
        <p class="step__text">Выписка из амбулаторной карты / Извещение о больном Ф090/У (для онкозаболеваний) / Выписка
          из Канцер-регистра (для онкозаболеваний)</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(2, $event)"
          name="files-vipiska[]" v-model="form.files.vipiska" />
      </template>
      <template v-for="el, index in dynamicFields.adds" :key="el.name + '~' + index">
        <p class="step__text" :class="{ 'step__text_required': el.required }">{{ el.text }}</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(100 + index, $event)"
          :name="el.name + '[]'" v-model="form.files[el.name]" />
      </template>
      <h4 v-if="dynamicFields.unadds.length > 0" class="step__title step__title_left">Дополнительные документы по риску
        Хищение деталей автомобиля (необязательно):</h4>
      <template v-for="el, index in dynamicFields.unadds" :key="el.name + '~' + index">
        <p class="step__text">{{ el.text }}</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(400 + index, $event)"
          :name="el.name + '[]'" v-model="form.files[el.name]" />
      </template>

      <!--      <h4 v-if="dynamicFields.criminalCase" class="step__title step__title_left">В случае ДТП или в результате получения телесных повреждений (НС):</h4>-->
      <p v-if="dynamicFields.criminalCase" class="step__text">Постановление о возбуждении/ отказе в возбуждении
        уголовного
        дела</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(3, $event)"
        v-if="dynamicFields.criminalCase" name="files-criminalCase[]" v-model="form.files.criminalCase" />
      <h4 v-if="dynamicFields.death" class="step__title step__title_left">В случае смерти:</h4>
      <p v-if="dynamicFields.death" class="step__text">Справка о смерти/ Медицинское свидетельство о смерти</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(4, $event)"
        v-if="dynamicFields.death" name="files-deathproof[]" v-model="form.files.deathproof" />
      <p v-if="dynamicFields.death" class="step__text">Свидетельство о праве на наследство по закону или справка о круге
        наследников</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(5, $event)"
        v-if="dynamicFields.death" name="files-legacyproof[]" v-model="form.files.legacyproof" />
      <p v-if="dynamicFields.death" class="step__text">Акт судебно-медицинского исследования трупа</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(6, $event)"
        v-if="dynamicFields.death" name="files-bodyresearchproof[]" v-model="form.files.bodyresearchproof" />
      <p v-if="dynamicFields.death" class="step__text">Акт протоколов вскрытия</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(7, $event)"
        v-if="dynamicFields.death" name="files-bodyautopsyproof[]" v-model="form.files.bodyautopsyproof" />
      <h4 v-if="dynamicFields.invalid" class="step__title step__title_left">В случае получения инвалидности:</h4>
      <p v-if="dynamicFields.invalid" class="step__text">Справка об установлении группы инвалидности</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(8, $event)"
        v-if="dynamicFields.invalid" name="files-invalidproof[]" v-model="form.files.invalidproof" />
      <p v-if="dynamicFields.invalid" class="step__text">Протокол медико-социальной экспертизы</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(9, $event)"
        v-if="dynamicFields.invalid" name="files-medprotocol[]" v-model="form.files.medprotocol" />
      <template v-for="beneficiary_index in dynamicFields.FATCA" :key="beneficiary_index">
        <h4 class="step__title step__title_left">Документы FATCA <span class="step__sm">({{
          form.beneficiaries[beneficiary_index].name }})</span></h4>
        <p class="step__text">Копия свидетельства, подтверждающего отказ от гражданства США</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts"
          @fileExtsChange="setFileExts(997 * (beneficiary_index + 1), $event)"
          :name="`files-b${beneficiary_index}-FATCA1[]`" v-model="form.files[`b${beneficiary_index}-FATCA1`]" />
        <p class="step__text">Копия отказа от статуса постоянного жителя США</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts"
          @fileExtsChange="setFileExts(998 * (beneficiary_index + 1), $event)"
          :name="`files-b${beneficiary_index}-FATCA2[]`" v-model="form.files[`b${beneficiary_index}-FATCA2`]" />
        <p class="step__text">Иной документ основание/заявление, подтверждающие отсутствие гражданства США</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts"
          @fileExtsChange="setFileExts(999 * (beneficiary_index + 1), $event)"
          :name="`files-b${beneficiary_index}-FATCA3[]`" v-model="form.files[`b${beneficiary_index}-FATCA3`]" />
      </template>
      <h4 class="step__title step__title_left">Дополнительные документы</h4>
      <p class="step__text">Прикрепить дополнительные документы</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(10, $event)"
        name="files-additinal[]" v-model="form.files.additinal" />
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="CheckExtsAndGoNext">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import FileInput from '../inputs/FileInput.vue';
import { mapState } from 'vuex';
import CyrillicToTranslit from 'cyrillic-to-translit-js';

export default {
  components: { FileInput, Btn },
  data: () => ({
    fileExts: [],
    forbiddenFileExts: [],
    refreshKey: 0,
    cyrillicToTranslit: new CyrillicToTranslit()
  }),
  props: {
    active: { type: Boolean }
  },
  methods: {
    setFileExts(index, array) {
      this.fileExts[index] = array
      this.refreshKey++
    },
    async CheckExtsAndGoNext() {
      try {
        let exts = Array.from(this.fileExts.flat())
        let res = await this.$store.dispatch('sendExts', exts.map(el => el.toLowerCase()))
        if (res === false) {
          return this.$store.dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            action: this.CheckExtsAndGoNext
          })
        }
        let forbidden = []
        for (let i = 0; i < res.length; i++)
          if (res[i])
            forbidden.push(exts[i])
        forbidden = Array.from(new Set(forbidden))
        this.forbiddenFileExts = forbidden
        if (this.forbiddenFileExts.length)
          return this.$store.dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Некоторые файлы имеют недопустимый формат',
            button: 'Ок',
          })
      } catch (err) {
        console.error(err)
        return this.$store.dispatch('showErrorPopup', {
          title: 'Ошибка!',
          text: 'Попробуйте повторить запрос',
          button: 'Повторить',
          action: this.CheckExtsAndGoNext
        })
      }
      this.$store.commit('nextStep')
    }
  },
  computed: {
    ...mapState(['form']),
    dynamicFields() {
      let obj = {
        criminalCase: false,
        death: false,
        invalid: false,
        vipiska: false,
        FATCA: [],
      }
      if (this.form.event.risktype == "Жизнь/Здоровье") {
        if (this.form.event.reason == 'Несчастный случай')
          obj.criminalCase = true
        if (this.form.event.type == 'Смерть') {
          obj.death = true
          obj.vipiska = true
        }
        if (this.form.event.type.toLowerCase().match(/^инвалидность/)) {
          obj.invalid = true
          obj.vipiska = true
        }
      }

      let adds = []
      let unadds = []

      const pstext = 'Паспорт получателя страхового возмещения' + (this.form.event.risktype == 'Жизнь/Здоровье' ? ', если отличается от основного' : '')

      switch (this.form.event.reason) {
        case "Травма":
          adds.push(
            pstext,
            'Рентгеновские снимки и/или их описание с заключением врача-рентгенолога по травме',
          )
          break
      }
      switch (this.form.event.type) {
        case "Купон":
        case "Дожитие":
          adds.push(
            pstext,
            'Селфи с паспортом',
            'Декларация налогового резиденства',
          )
          for (let i = 0; i < this.form.beneficiaries.length; i++)
            if (this.form.beneficiaries[i].FATCA.renunciation == 'Да')
              obj.FATCA.push(i)
          break
        case "Критическое заболевание":
          adds.push(
            pstext,
            'Направление лечащего Врача на плановое стационарное лечение',
            'Результаты проведенных анализов и исследований, на основании которых был поставлен диагноз и назначено лечение',
          )
          break
        case "Временная нетрудоспособность":
          adds.push(
            pstext,
            'Все листки нетрудоспособности, оформленные и принятые на оплату органом/ учреждением/организацией, который располагает оригиналами предоставленных листков нетрудоспособности (электронный лист нетрудоспособности /копия, заверенная работодателем)',
            'Справка 2-НДФЛ, содержащая информацию о размере заработной платы, в том числе за 3 месяца, предшествовавших временной утрате трудоспособности',
          )
          break

        case "Залив":
          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Акт обследования технического состояния объекта с указанием даты, причины и виновника залива с печатью, выдавшего учреждения',
          )
          break
        case "Пожар":
          obj.criminalCase = true

          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Акт о пожаре МЧС России или донесение о пожаре',
            'Результаты пожарно-технической экспертизы',
            // 'Постановление о возбуждении уголовного дела или постановление об отказе в возбуждении уголовного дела',
          )
          break
        case "Взрыв":
          obj.criminalCase = true

          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Акт или справка из МЧС России',
            // 'Постановление о возбуждении уголовного дела или постановление об отказе в возбуждении уголовного дела',
          )
          break
        case "Стихийное бедствие":
          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Справка Федеральной службы РФ по гидрометеорологии и мониторингу окружающей среды или справка МЧС России',
          )
          break
        case "Удар молнии":
          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Справка Федеральной службы РФ по гидрометеорологии и мониторингу окружающей среды или справка МЧС России',
          )
          break
        case "Механические повреждения":
          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Справка ГИБДД, ДЕЗ, ЖЭУ, сельской администрации, полиции, лесничества, МЧС, Межгосударственного авиационного комитета (МАК) и т.д',
          )
          break
        case "Противоправные действия":
          obj.criminalCase = true

          adds.push(
            pstext,
            'Выписка из ЕГРН',
            // 'Постановление о возбуждении уголовного дела или постановление об отказе в возбуждении уголовного дела',
            'Чеки, счета, квитанции, акты на украденное имущество',
          )
          break
        case "Повреждение имущества соседей":
          adds.push(
            pstext,
            'Выписка из ЕГРН',
            'Документы, выданные компетентными органами или организациями в связи с произошедшим событием, подтверждающие наступление события, имеющего признаки страхового случая, с указанием причины, даты и времени его возникновения и описанием причиненного ущерба',
          )
          break
        case "Титул (утрата собственности)":
          adds.push(
            'Копия документа, удостоверяющего личность Заявителя и Выгодоприобретателя',
            'Исковое заявление, решение суда, определение об отмене ареста на застрахованное имущество (если таковой был наложен ранее)',
          )
          break
        case "Досрочное прекращение аренды":
          adds.push(
            pstext,
            'Смс/@/письма, подтверждающие досрочное прекращение договора аренды',
            'Подтверждение оплаты аренды',
            'Договор аренды',
            'Счета, квитанции, иные платежные док-ты, подтверждающие размер расходов на проживание/перевозку вещей (при возникновении таких расходов)',
          )
          break
        case "Потеря работы/Снижение ЗП":
          adds.push(
            pstext,
            'Письменное уведомление работодателя об увольнении с указанием его причин',
            'Приказ об увольнении',
            'Соглашение о расторжении трудового договора',
            'Трудовая книжка (все страницы) с отметкой об увольнении, заверенная нотариально или бывшим работодателем',
            'Трудовой договор с места работы со всеми дополнениями',
            'Справка 2-НДФЛ',
            'Справка из «Центр занятости населения»',
          )
          break
        case "Полная гибель":
          adds.push(
            pstext,
            'Водительское удостоверения водителя',
            'ПТС, свидетельство о регистрации ТС',
            'Справка о ДТП',
            'Отчет об оценке независимого оценщика, содержащий вывод о том, что восстановление транспортного средства экономически нецелесообразно',
            'Страховой акт с указанием размера выплаты по договору добровольного страхования средств автотранспорта',
            'Отчет об оценке независимого оценщика, содержащий расчет стоимости годных остатков ТС, или иной документ Страховщика КАСКО, содержащий данную информацию (если транспортное средство было застраховано по договору добровольного страхования автотранспортного средства)',
          )
          break
        case "Хищение деталей автомобиля":
          adds.push(
            pstext,
            'ПТС, свидетельства о регистрации ТС',
            'Постановление ОВД',
            'Страховой акт с указанием размера выплаты по договору добровольного страхования средств автотранспорта',
          )
          break
        case "Поломка":
          adds.push(
            pstext,
            'ПТС, свидетельства о регистрации ТС (СТС)',
            'Фотографии места происшествия',
            'Фотография одометра',
            'Чеки, подтверждающие оплату услуг по ремонту или замене',
            'Заказ-наряд СТО',
          )
          break
        case "Повреждения шин или дисков":
          adds.push(
            pstext,
            'ПТС, свидетельства о регистрации ТС (СТС)',
            'Фотографии места происшествия',
            'Фотографии поврежденного колеса или колес, шин',
            'Фотография одометра',
            'Фотографии отремонтированных колеса или колес, шин',
            'Чеки, подтверждающие оплату услуг по ремонту или замене',
          )
          //Дополнительно по риску Хищение шин или дисков: (ДОПОЛНИТЕЛЬНЫЕ ДОКУМЕНТЫ - НЕОБЯЗАТЕЛЬНЫЕ)
          unadds.push(
            'Копия постановления о возбуждении уголовного дела',
            'Копия документов о приобретении похищенных шин и дисков, в тч. при приобретении вместе с ТЗ спецификация, подтверждающая наличие указанных шин и дисков на ТС',
            'Копия чека/договора на приобретение новых шин и дисков в замен украденных (похищенных) с подтверждение факта оплаты',
          )
          break
        case "Утрата банковской карты":
          adds.push(
            pstext,
            'Выписка по текущему счету, подтверждающая факт проведения несанкционированных транзакций',
            'Банковская выписка со счета, подтверждающая факт списания банковской комиссии за перевыпуск Карты',
            'Результат опротестования операций',
          )
          break
        case "Утрата денежных средств":
          adds.push(
            pstext,
            'Выписка по текущему счету, подтверждающая факт проведения несанкционированных транзакций',
            'Постановление о возбуждении / об отказе в возбуждении уголовного дела с указанием даты, обстоятельств события и причиненного ущерба',
            'Отчет уполномоченного структурного подразделения Банка эмитента о заявленных несанкционированных транзакциях с указанием даты, времени, суммы каждой опротестовываемой операции, текущем статусе рассмотрения обращения Владельца счета',
          )
          break
        case "Утеря ключей/документов/имущества":
          adds.push(
            pstext,
            'Фискальный чек или товарный чек (накладная) на оплату расходов по изготовлению ключей и запирающих устройств от жилого помещения и или автомобиля) и/или покупке мобильного телефона, содержащие сведения о факте покупки, сумме и назначении платежа',
            'Квитанция по оплате гос. пошлины на восстановление личных документов, содержащие сведения сумме и назначении платежа',
            'Постановление о возбуждении / об отказе в возбуждении уголовного дела с указанием даты, обстоятельств события и причиненного ущерба',
          )
          break
        case "Поломка имущества":
          adds.push(
            pstext,
            'Фото поломки',
            'Документ, подтверждающих техническую неисправность',
          )
          break
        case "Повреждение имущества при доставке":
          adds.push(
            pstext,
            'Акт о поломке',
            'Фото поломки',
          )
          break
      }

      // Исключаем дубли элементов
      adds = Array.from(new Set(adds));
      unadds = Array.from(new Set(unadds));

      const requiredAdds = ['Паспорт получателя страхового возмещения', 'Селфи с паспортом']

      obj.adds = adds.map(el => ({
        text: el,
        name: 'files-' + this.cyrillicToTranslit.transform(el, '_').toLowerCase().split('_').slice(0, 5).join('_').replace(/[^a-z0-9_]/g, '_').replace(/^_+|_+$/g, '').replace(/_{2,}/g, '_'),
        required: requiredAdds.includes(el)
      }))

      obj.unadds = unadds.map(el => ({
        text: el,
        name: 'files-' + this.cyrillicToTranslit.transform(el, '_').toLowerCase().split('_').slice(0, 5).join('_').replace(/[^a-z0-9_]/g, '_').replace(/^_+|_+$/g, '').replace(/_{2,}/g, '_')
      }))
      return obj
    },
    filled() {
      // let required = [] //'blank', 'passport', 'vipiska'

      /*
      if (this.dynamicFields.death) 
        required.push('deathproof')
      if (this.dynamicFields.invalid)
        required.push('invalidproof')
      */
      /*if (this.dynamicFields.FATCA)
        required.push('FATCA1','FATCA2','FATCA3')
      if (this.dynamicFields.adds.length)
        for (let el of this.dynamicFields.adds)
          required.push(el.name)
      for (let key of required)
        if (!this.form.files[key] || !this.form.files[key].length) return false
      if (this.forbiddenFileExts.length) {
        let set = new Set(this.fileExts.flat())
        for (let ext of this.forbiddenFileExts)
          if (set.has(ext))
            return false
      }*/

      this.refreshKey;
      let required = []

      if (this.dynamicFields.adds.length)
        for (let el of this.dynamicFields.adds) {
          if (el.required)
            required.push(el.name)
        }
      for (let key of required)
        if (!this.form.files[key] || !this.form.files[key].length) return false

      return true
    },
  }
}
</script>

<style lang="sass">

</style>